import animaltypes from './animaltypes'
import farms from './farms'
import groups from './groups'
import ingredients from './ingredients'
import ingredienttypes from './ingredienttypes'
import mixers from './mixers'
import rations from './rations'
import stocks from './stocks'

export default {
  animaltypes,
  farms,
  groups,
  ingredients,
  ingredienttypes,
  mixers,
  rations,
  stocks
}
